import { ActionTree } from 'vuex';
import { RootState } from '../types';

import {
    UserState, ActionError,
    LoginForm,
} from './types';

import API, { CLEAR_API_DEFAULT } from '@/utils/api/index';
import { AxiosResponse, AxiosError } from 'axios';

export const actions: ActionTree<UserState, RootState> = {
    LOGIN: async ({commit, dispatch, getters}, payload: LoginForm) => {
        if (getters['IS_LOGIN']) {
            await dispatch('LOGOUT_BEFORE_LOGIN');
        }
        let response;
        // axios try
        try {
            response =  await API.adserverAPI.post('/Signin', payload);
            const err: AxiosError = {
                stack: (new Error()).stack,
                config: response.config,
                message: (new Error()).message,
                name: (new Error()).name,
                code: response.status.toString(),
                request: response.request,
                response: response,
            };
            switch (response.data.text) {
                case 'ok':
                    break
                case 'not-found-customer':
                    err.response!.status = 404
                case 'not-found-iam-user':
                    err.response!.status = 403
                    throw err
            }
        } catch (err) {
            if (err.response) {
                switch(err.response.status) {
                    case 404: err.type = ActionError.HTTP_LOGIN_RESPONSE_NOT_FOUND;
                        break;
                    case 403: err.type = ActionError.HTTP_LOGIN_RESPONSE_NOT_MATCHED;
                        break;
                    default: err.type = ActionError.HTTP_LOGIN_RESPONSE_NOT_MATCHED;
                };
            } else {
                err.type = ActionError.HTTP_LOGIN_RESPONSE_NOT_MATCHED;
            }
            throw err;
        }

        // vuex try
        try {
            commit('SET_USER', {
                token: response.data.access_token,
                keepLogin: payload.keepLogin,
            });
        } catch (err) {
            err.type = ActionError.VUEX_SET_USER;
            throw err;
        }
    },
    LOGOUT_BEFORE_LOGIN: async ({commit, state}) => {
        window.localStorage.clear();

        if (!state || !state.token) {
            return;
        }

        // vuex try
        try {
            await API.adserverAPI.post('/Signout', {}, {
                headers: {
                    Authorization: `Bearer ${state.token}`
                }
            });
            CLEAR_API_DEFAULT();
            commit('CLEAR_USER');
            commit('CLEAR_CUSTOMER_INFO');
        } catch (err) {
            err.type = ActionError.VUEX_CLEAR_USER;
            throw err;
        }
    },
    LOGOUT: async ({commit, dispatch, state}) => {
        window.localStorage.clear();

        if (!state || !state.token) {
            return;
        }

        // vuex try
        try {
            await API.adserverAPI.post('/Signout', {}, {
                headers: {
                    Authorization: `Bearer ${state.token}`
                }
            });
            CLEAR_API_DEFAULT();
            commit('CLEAR_USER');
            commit('CLEAR_CUSTOMER_INFO');
            await dispatch('SHOW_WELCOME_NOTICE')
        } catch (err) {
            err.type = ActionError.VUEX_CLEAR_USER;
            throw err;
        }
    },
    REFRESH_TOKEN: async ({commit, state}) => {
        if (!state.keepLogin) {
            throw new Error('NOT_KEEP_LOGIN_ERROR');
        }
        let response;
        // axios try
        try {
            const {data} = await API.adserverAPI.post('/RenewToken', {}, {
                headers: {
                    Authorization: `Bearer ${state.token}`,
                },
            });
            response = data;
            if (!data.result) {
                const err: AxiosError = {
                    stack: (new Error()).stack,
                    config: response.config,
                    message: (new Error()).message,
                    name: (new Error()).name,
                    code: response.status.toString(),
                    request: response.request,
                    response: response,
                };
                err.response!.status = 403;
                throw err;
            }
        } catch (err) {
            if (err.response && (err.response as AxiosResponse).status === 403) {
                err.type = ActionError.HTTP_LOGIN_RESPONSE_NOT_MATCHED
            } else {
                err.type = ActionError.HTTP_REFRESH;
            }
            throw err;
        }
        
        try {
            await commit('CLEAR_CUSTOMER_INFO');
        } catch (err) {
            throw err;
        }
        // vuex try
        try {
            commit('SET_USER', {
                token: response.access_token,
                keepLogin: state.keepLogin,
            });
        } catch (err) {
            err.type = ActionError.VUEX_SET_USER;
            throw err;
        }
    },
    SET_CUSTOMER_INFO: async ({commit, dispatch, getters, state}) => {
        if (!getters['IS_LOGIN']) {
            const err = new Error('IS_NOT_LOGIN') as any;
            err.type = ActionError.IS_NOT_LOGIN;
            throw err;
        }

        let response;
        try {
            const {data} = await API.adserverAPI.post('GetCustomerMeta', {
                'customer_id': state.email,
            });
            if (data && data.company_no && data.customer_no && data.customer_id) {
                response = data;
            } else {
                throw new Error('has no customer data');
            }
        } catch (err) {
            await dispatch('LOGOUT');
            err.type = ActionError.ERR_GET_CUSTOMER_INFO;
            throw err;
        }

        try {
            commit('SET_CUSTOMER_INFO', {
                company_no: response.company_no,
                customer_no: response.customer_no,
                customer_id: response.customer_id,
            });
        } catch (err) {
            err.type = ActionError.ERR_SET_CUSTOMER_INFO;
            throw err;
        }
    },
    SHOW_WELCOME_NOTICE: async ({commit}) => {
        commit('SHOW_WELCOME_NOTICE');
    },
    CLOSE_WELCOME_NOTICE: async ({commit}) => {
        commit('CLOSE_WELCOME_NOTICE');
    }
};
